<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 lg4>
        <v-card class="dash-card elevation-3">
          <v-img src="../../../static/img/tutorial.jpg" height="150px"></v-img>
          <v-card-title primary-title>
            <v-layout row>
              <v-flex>
                <div class="headline">{{getString('Video Tutorial')}}</div>
                <span
                  class="grey--text"
                >{{getString('Qui trovi i tutorial raggruppati per categoria')}}</span>
                <v-radio-group row v-model="catSelected">
                  <v-radio color="red lighten-2" v-for="n in cats" :key="n" :label="n" :value="n"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-list two-line>
            <template v-for="(item, index) in listItemFiltered">
              <v-list-tile :key="index" avatar ripple @click="selectVideo(item.value)">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <b>{{ item.title }}</b>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary">{{ item.headline }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider v-if="index + 1 < listItemFiltered.length" :key="index +'_' "></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 lg8>
          <v-card class="dash-card elevation-3">
              <v-card-text>
                  <v-layout row>
                    <v-flex xs12 v-if="vidSelected === 0" >
                      <iframe style="width:100%;min-height:650px" src="https://www.youtube.com/embed/YmgEQjJL4lw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      <h3>{{getString('QuickBe Tutorial - Descrizione negozio')}}</h3>
                      <p>{{getString('Ciao, questo tutorial ti permetterà di capire come puoi personalizzare le informazioni del tuo negozio. Come settare i recapiti, i link ai social, il listo, etc.')}}</p>
                    </v-flex>
                    <v-flex xs12 v-if="vidSelected === 1" >
                      <iframe style="width:100%;min-height:650px" src="https://www.youtube.com/embed/b0t28PHAdmU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      <h3>{{getString('QuickBe Tutorial - Orari negozio')}}</h3>
                      <p>{{getString(`Ciao, qui imparerai come impostare i giorni di apertura, gli orari, i giorni di prenotazione ed i giorni di chiusura del tuo negozio!`)}}</p>
                    </v-flex>
                    <v-flex xs12 v-if="vidSelected === 2" >
                      <iframe style="width:100%;min-height:650px" src="https://www.youtube.com/embed/GTuuDaLpO1s" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      <h3>{{getString('QuickBe Tutorial - Galleria foto')}}</h3>
                      <p>{{getString('Ciao, qui puoi imparare come gestire al meglio le gallerie del tuo negozio.')}}</p>
                    </v-flex>
                    <v-flex xs12 v-if="vidSelected === 3" >
                      <iframe style="width:100%;min-height:650px" src="https://www.youtube.com/embed/mF0QlrEdq3k" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      <h3>{{getString('QuickBe Tutorial - Gestione dipendenti e blocco utenza')}}</h3>
                      <p>{{getString(`Ciao, in questo tutorial imparerai come manutenere i dipendenti del tuo negozio e come bloccare l'utenza.`)}}</p>
                    </v-flex>
                    <v-flex xs12 v-if="vidSelected === 4" >
                      <iframe style="width:100%;min-height:650px" src="https://www.youtube.com/embed/c_9y6XOb8Rg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      <h3>{{getString('QuickBe Tutorial - Opzioni negozio e QuickBe Plaza')}}</h3>
                      <p>{{getString(`Ciao, qui imparerai ad impostare i settaggi principali del tuo negozio per l'uso dall'app, come i tempi delle prenotazioni, il massimo numero di prenotazioni, i tempi, etc. Inoltre qui imparerai ad impostare QuickBe Plaza, per presentare al meglio il tuo negozio!`)}}</p>
                    </v-flex>
                    <v-flex xs12 v-if="vidSelected === 5" >
                      <iframe style="width:100%;min-height:650px" src="https://www.youtube.com/embed/tPKlvV2Lnjg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      <h3>{{getString('QuickBe Tutorial - Calendario Prenotazioni')}}</h3>
                      <p>{{getString(`Ciao, qui puoi imparare a gestire le tue prenotazioni sul calendario di QuickBe.`)}}</p>
                    </v-flex>
                    <v-flex xs12 v-if="vidSelected === 6" >
                        <iframe style="width:100%;min-height:650px" src="https://www.youtube.com/embed/FRvnnzbGeLo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <h3>{{getString('QuickBe Tutorial - Calendario Funzioni')}}</h3>
                        <p>{{getString(`Ciao, qui puoi imparare le principali funzioni del calendario.`)}}</p>
                    </v-flex>
                    <v-flex xs12 v-if="vidSelected === 7" >
                      <iframe style="width:100%;min-height:650px" src="https://www.youtube.com/embed/cSbQPPhEMYI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      <h3>{{getString('QuickBe Tutorial - Comunicazioni')}}</h3>
                      <p>{{getString(`Ciao, qui imparerai come inviare delle comunicazioni ai tuoi utenti attraverso le notifiche push delle app.`)}}</p>
                    </v-flex>

                  </v-layout>
              </v-card-text>
          </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ajax from "../../ajax.js";

export default {
  name: "VideoTutorial",
  mounted: function() {},
  data: () => {
    return {
        catSelected: 'Configurazione',
        vidSelected: 0
    };
  },
  computed: {
    cats: function() {
      var result = [];
      for (let index = 0; index < this.listItems.length; index++) {
        var contains = false;
        const element = this.listItems[index];
        for (let i = 0; i < result.length; i++) {
          const element1 = result[i];
          if (element1 === element.title) contains = true;
        }
        if (!contains) result.push(element.title);
      }
      return result;
    },
    listItemFiltered: function(){
        var result = []
        for (let index = 0; index < this.listItems.length; index++) {
            const element = this.listItems[index];
            if(element.title === this.catSelected)
                result.push(element)
        }
        return result
    },
    listItems: function() {
      return [
        {
          title: this.getString("Configurazione"),
          headline: this.getString("Vetrina negozio"),
          subtitle: this.getString(
            "Descrizione, link social, listino, codici, contatti, etc."
          ),
          value : 0
        },
        {
          title: this.getString("Configurazione"),
          headline: this.getString("Orari"),
          subtitle: this.getString(
            "Orari di apertura giornalieri, continuità, giorni di chiusura, etc."
          ),
          value : 1
        },
        {
          title: this.getString("Configurazione"),
          headline: this.getString("Gallerie"),
          subtitle: this.getString(
            "Creazione e cancellazione gallerie, rinomine, caricamenti massivi foto, etc."
          ),
          value : 2
        },
        {
          title: this.getString("Configurazione"),
          headline: this.getString("Dipendenti e clienti"),
          subtitle: this.getString(
            "Creazione o modifica dipendenti, visualizzazione clienti e blocco"
          ),
          value : 3
        },
        {
          title: this.getString("Configurazione"),
          headline: this.getString("Opzioni negozio e Plaza"),
          subtitle: this.getString(
            "Configurazione delle opzioni del negozio (tempi, suoni, etc.) e di QuickBe Plaza (tema, link, etc.)"
          ),
          value : 4
        },
        {
          title: this.getString("Calendario"),
          headline: this.getString("Prenotazioni"),
          subtitle: this.getString(
            "Come gestire le prenotazioni, cancellazione, aggiunta, ricezione, etc."
          ),
          value : 5
        },
        {
          title: this.getString("Calendario"),
          headline: this.getString("Calendario funzionalità"),
          subtitle: this.getString(
            "Blocco utenza, assenze dipendenti, spiegazione, fullscreen, audio, etc."
          ),
          value : 6
        },
        {
          title: this.getString("Comunicazioni"),
          headline: this.getString("Invio di comunicazioni"),
          subtitle: this.getString("Invia e gestisci le tue comunicazioni"),
          value : 7
        }
      ];
    }
  },
  methods: {
    selectVideo: function(val) {
      this.vidSelected = val
    },
    openDewStudio: function() {
      window.open("https://www.dewstudio.eu");
    },
    getString: function(key, values) {
      return this.$store.state.currentTranslator.getString(key, values);
    }
  }
};
</script>

<style scoped>
.center {
  text-align: center;
}

.border {
  border: 2px solid;
}

.logo-size {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/VideoTutorial.vue